import { DInfoResumenFormulario } from '@dian/api-formulario';

export class DDocumentoEnDiligenciamientoVista extends DInfoResumenFormulario {  
    
    nombre: string;
    vencimiento: Date;
    descripcion: string;
    colorAlerta: string;

    constructor() {
        super();
    }
    
}


// WEBPACK FOOTER //
// D:/AngularProjects/Angular Projects/Formularios/src/app/to/ddocumento-en-diligenciamiento-vista.ts